<ui-card>
    <app-segment-header
        class="margin-bottom-1"
        title="applicant-tracker.components.required-fields-card.requiredFieldsForApplicants"
    ></app-segment-header>
    <p class="margin-bottom-2">
        {{ 'applicant-tracker.components.required-fields-card.selectTheFieldsYouRequire' | appTranslate }}
    </p>
    <div class="margin-left-4" *ngFor="let field of fields">
        <mat-checkbox
            class="columns-12 margin-bottom-2 interview-question-checkbox"
            [name]="field.name"
            type="checkbox"
            [disabled]="field.disabled"
            [checked]="field.checked"
            (change)="onCheck($event, field)"
        >
            {{ field.label | appTranslate }}
        </mat-checkbox>
    </div>
</ui-card>
